import AdminBoatPlaceList from '../components/AdminBoatPlaceList';
import { useAllBoatPlaces } from '../lib/boats';
import { useAllMembers } from '../lib/members';

export default function AdminBoatPlaces() {
  const { places, loading: lp } = useAllBoatPlaces();
  const { members, loading: lm } = useAllMembers();
  if (lp || lm) return <p>Laddar…</p>;
  return <AdminBoatPlaceList places={places} members={members} />;
}
